import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import type { ComplianceStatus } from "@/store/complianceStore";

const COPY: Record<ComplianceStatus, string> = { pending: "Still to check", compliant: "All good", flagged: "Needs a look" };

export function ComplianceStatusDot({ status }: { status: ComplianceStatus }) {
  return (
    <span className="flex shrink-0 items-center gap-3">
      <span
        data-testid={`status-${status}`}
        aria-label={COPY[status]}
        className={cn(
          "flex h-6 w-6 items-center justify-center rounded-full border-[1.5px] transition-colors duration-300",
          status === "pending" && "border-safety/80",
          status === "compliant" && "border-safety bg-safety shadow-[0_0_14px_-2px_rgba(255,91,0,0.7)]",
          status === "flagged" && "border-amber",
        )}
      >
        {status === "compliant" && (
          <motion.svg width="12" height="12" viewBox="0 0 12 12" fill="none" initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: "spring", stiffness: 500, damping: 26 }} aria-hidden>
            <path d="M2.5 6.5 5 9l4.5-6" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          </motion.svg>
        )}
        {status === "flagged" && <span aria-hidden className="h-1.5 w-1.5 rounded-full bg-amber" />}
      </span>
      <span className={cn("hidden font-mono text-[10px] uppercase tracking-[0.18em] sm:block", status === "flagged" ? "text-amber" : status === "compliant" ? "text-safety" : "text-cad")}>
        {COPY[status]}
      </span>
    </span>
  );
}
